import React from "react";
import _ from "lodash";
import NetflixTray from "../Tray/Video/netflix-tray";
import { onUserAuth } from "../../redux/user/helpers";
import { fetchHistory } from "../../redux/uservideo/helpers";

import "./style.scss";

class WatchHistoryHorizontal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { records: null };
  }

  render() {
    return (
      <div className={`watch-history ${this.state.records ? "" : "empty"}`}>
        {!_.isEmpty(this.state.records) && this.renderHistoryTray()}
      </div>
    );
  }

  componentDidMount() {
    onUserAuth(user => {
      if (!user) return this.setState({ ...this.state, records: null });
      fetchHistory(user.userId).then(r => {
        this.setState({ ...this.state, records: r });
      });
    });
  }

  renderHistoryTray() {
    const props = {
      noBlockTitle: true,
      data: {
        title: this.props.data.title,
        contentData: this.state.records.map(x => x.contentResponse),
        settings: {
          seeAll: true,
          seeAllPermalink: "/user/history"
        }
      },
      layout: this.props.layout
    };
    return (
      <NetflixTray
        {...props}
        showCount={false}
        netflix={true}
        hideCategories={true}
        showProgressBar={true}
        showDetailsBottom={true}
        showPlayIcon={true}
        draggable={false}
        neouTrayTitle={true}
      />
    );
  }
}

export default WatchHistoryHorizontal;
